import { LibraryRegular, LibraryFilled, GlobeRegular, GlobeFilled } from '@fluentui/react-icons';
import { createCompositeIcon } from './createCompositeIcon';

/**
 * Global library = library icon with a globe badge.
 * We expose separate `Regular` / `Filled` variants (Fluent-UI style).
 */
export const { regular: GlobalLibraryRegular, filled: GlobalLibraryFilled } = createCompositeIcon(
  // background / base layer
  {
    regular: LibraryRegular,
    filled: LibraryFilled,
    props: {
      scale: 0.95,
      offsetX: 2.25, // push inwards a tiny bit
      offsetY: -1.5,
    },
  },

  // foreground / overlay layer
  // NOTE: regular/filled are intentionally swapped for contrast -
  // a filled badge on an outlined base, and vice versa.
  {
    regular: GlobeFilled,
    filled: GlobeRegular,
    props: {
      scale: 0.6, // smaller badge
      offsetX: -1.5,
      offsetY: 12,
    },
  }
);
